import { memo } from "react";
import { useTheme } from "../../hooks/useTheme";

type HorizontalDividerWithTextProps = {
  text: string;
};

// ---- Some Text ----
export const HorizontalDividerWithText = memo(
  function HorizontalDividerWithTextFn(props: HorizontalDividerWithTextProps) {
    const { text } = props;
    const { theme } = useTheme();

    const styles = {
      divider: {
        flex: 1,
        minWidth: 0,
        height: 0.5,
        backgroundColor: theme.EditableTextFieldBorder.borderColor,
      },
    };

    return (
      <div className="AlignedRow" style={{ width: "100%", gap: 10 }}>
        <div style={styles.divider} />
        <span
          className="smallBodySubtext"
          style={{ flexShrink: 0, whiteSpace: "nowrap" }}
        >
          {text}
        </span>
        <div style={styles.divider} />
      </div>
    );
  }
);
